const fontWeight = {
  light: 300,
  regular: "normal",
  medium: 500,
  bold: "bold",
  xBold: 900,
};

export default fontWeight;
